import React, { createContext, useCallback, useContext, useEffect, useRef, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { labelsRequest, labelsVersion, setLabels, subscribeLabels } from './labels';

const LabelsContext = createContext({ refresh: async () => {} });
export const useLabelVersion = () => useSyncExternalStore(subscribeLabels, labelsVersion, labelsVersion);
export function useLabels() {
  const version = useLabelVersion();
  return { ...useContext(LabelsContext), version };
}
export default function LabelsProvider({ server, children }) {
  useLocation();
  const username = localStorage.getItem('username');
  const generation = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++generation.current;
    try {
      const data = username && server ? await labelsRequest(server, '/etiquetas') : {};
      if (current === generation.current) setLabels(data);
    } catch {
      if (current === generation.current) setLabels({});
    }
  }, [server, username]);
  useEffect(() => {
    setLabels({});
    refresh();
    return () => { generation.current += 1; setLabels({}); };
  }, [refresh]);
  // Reading location makes same-window login/logout observable; labels never persist across sessions.
  return <LabelsContext.Provider value={{ refresh }}>{children}</LabelsContext.Provider>;
}
